export default __webpack_public_path__ + "static/media/dra-ivani.298d4469.png";